<template>
  <b-modal
    :id="id"
    ref="bModal"
    centered
    :ok-title="$tc(okTitle)"
    ok-only
    ok-variant="link"
    :modal-class="type"
    style="z-index:9999"
    @ok="$emit('ok')"
    @hide="onHide"
    @keyup.native.enter="hide"
  >
    <b-row class="d-flex justify-content-center mb-3">
      <b-col
        cols="3"
        class="text-center"
      >
        <div class="alert-circle">
          <i
            :class="icon"
            aria-hidden="true"
          />
        </div>
      </b-col>
    </b-row>
    <div
      class="vt-modal__main-text"
      style="word-wrap: break-word;"
      v-html="displayContent"
    />
  </b-modal>
</template>

<script>
const SUCCESS = 'vt-modal vt-modal--success'
export default {

    name: 'ModalStates',
    props: {
        id: { type: String, required: true },
        content: { type: String },
        okTitle: { type: String, default: 'global.close' }
    },
    data() {
        return {
            contentOverride: null,
            icon: null,
            type: null
        }
    },
    computed: {
        displayContent() {
            return this.contentOverride || this.content
        }
    },
    methods: {
        show(content, icon, type, hideAutomatically = true) {
            if (content) {
                this.contentOverride = content
            }
            this.icon = icon
            this.type = type
            this.$refs.bModal.show()
            if (hideAutomatically) {
                setTimeout(this.hide, 2000)
            }
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHide() {
            this.contentOverride = null
            this.$emit('hide')
            this.$eventHub.$emit('focus-searcherModule')
            if (this.type === SUCCESS) {
                this.$eventHub.$emit('onModalStatesSuccessHide')
            } else {
                this.$eventHub.$emit('onModalStatesErrorHide')
            }
        }
    }
}

</script>
